"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.oldApiClient = exports.apiClient = void 0;
const axios_1 = __importDefault(require("axios"));
const humps_1 = require("humps");
const apiClient = axios_1.default.create({
    baseURL: process.env.API_STREAM_URL,
});
exports.apiClient = apiClient;
const oldApiClient = axios_1.default.create({
    baseURL: process.env.API_BASE_URL,
});
exports.oldApiClient = oldApiClient;
apiClient.interceptors.response.use((response) => {
    response.data = (0, humps_1.camelizeKeys)(response.data);
    return response;
});
oldApiClient.interceptors.response.use((response) => {
    response.data = (0, humps_1.camelizeKeys)(response.data);
    return response;
});
